import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_STARTUP } from "../graphql/mutations";
import {
  INDUSTRIES,
  LEGAL_FORMS,
  BUSINESS_MODELS,
  ECOSYSTEMS,
  INTROLES,
  FDN,
  WDW,
  MCN,
  MAN,
} from "../graphql/queries";
import CustomSelect from "./CustomSelect";
import { Link } from "react-router-dom";

// eslint-disable-next-line no-unused-vars
const axios = require("axios");

function CreateStartup() {
  // Fetch legal forms
  const [legalForms, setLegalForms] = useState();
  const legalFormsQuery = useQuery(LEGAL_FORMS);
  useEffect(() => {
    if (legalFormsQuery?.data) {
      const dataReceived = legalFormsQuery?.data?.legRanges?.data?.map(
        (legalForm) => ({
          value: legalForm.id,
          label: legalForm.attributes.value,
        })
      );

      setLegalForms(dataReceived);
    }
  }, [legalFormsQuery?.data, legalFormsQuery?.error]);

  // Fetch industries
  const [industries, setIndustries] = useState();
  const industriesQuery = useQuery(INDUSTRIES);
  useEffect(() => {
    if (industriesQuery.data) {
      const dataReceived = industriesQuery?.data?.indRanges?.data?.map(
        (industry) => ({ value: industry.id, label: industry.attributes.value })
      );

      setIndustries(dataReceived);
    }
  }, [industriesQuery?.data, industriesQuery?.error]);

  // Fetch business models
  const [businessModels, setBusinessModels] = useState();
  const businessModelsQuery = useQuery(BUSINESS_MODELS);
  useEffect(() => {
    if (businessModelsQuery.data) {
      const dataReceived = businessModelsQuery.data?.modRanges?.data?.map(
        (businessModel) => ({
          value: businessModel.id,
          label: businessModel.attributes.value,
        })
      );

      setBusinessModels(dataReceived);
    }
  }, [businessModelsQuery?.data, businessModelsQuery?.error]);

  // Fetch startup ecosystems
  const [ecosystems, setEcosystems] = useState();
  const ecosystemsQuery = useQuery(ECOSYSTEMS);
  useEffect(() => {
    if (ecosystemsQuery?.data) {
      const dataReceived = ecosystemsQuery?.data?.ecoRanges?.data?.map(
        (ecosystem) => ({
          value: ecosystem.id,
          label: ecosystem.attributes.value,
        })
      );

      setEcosystems(dataReceived);
    }
  }, [ecosystemsQuery?.data, ecosystemsQuery?.error]);

  // Fetch INTROLES
  const [intranges, setIntranges] = useState();
  const intrangesQuery = useQuery(INTROLES);
  useEffect(() => {
    if (intrangesQuery?.data) {
      const dataReceived = intrangesQuery?.data.intRanges?.data.map(
        (intranges) => ({
          value: intranges.id,
          label: intranges.attributes.value,
        })
      );

      setIntranges(dataReceived);
    }
  }, [intrangesQuery?.data, intrangesQuery.error]);

  // Fetch FDN
  const [fdns, setFdns] = useState([]);
  const fdnsQuery = useQuery(FDN);
  useEffect(() => {
    if (fdnsQuery?.data) {
      const dataReceived = fdnsQuery?.data.fdnRanges?.data?.map((fdns) => ({
        value: fdns.id,
        label: fdns.attributes.value,
      }));

      setFdns(dataReceived);
    }
  }, [fdnsQuery?.data, fdnsQuery.error]);

  // Fetch WDW
  const [wdws, setWdws] = useState([]);
  const wdwsQuery = useQuery(WDW);
  useEffect(() => {
    if (wdwsQuery?.data) {
      const dataReceived = wdwsQuery?.data.wdwRanges?.data?.map((wdws) => ({
        value: wdws.id,
        label: wdws.attributes.value,
      }));

      setWdws(dataReceived);
    }
  }, [wdwsQuery?.data, wdwsQuery.error]);

  // Fetch MCN
  const [mcns, setMcns] = useState([]);
  const mcnsQuery = useQuery(MCN);
  useEffect(() => {
    if (mcnsQuery?.data) {
      const dataReceived = mcnsQuery?.data.mcnRanges?.data?.map((mcns) => ({
        value: mcns.id,
        label: mcns.attributes.value,
      }));

      setMcns(dataReceived);
    }
  }, [mcnsQuery?.data, mcnsQuery.error]);

  // Fetch MAN
  const [mans, setMans] = useState([]);
  const mansQuery = useQuery(MAN);
  useEffect(() => {
    if (mansQuery?.data) {
      const dataReceived = mansQuery?.data.manRanges?.data?.map((mans) => ({
        value: mans.id,
        label: mans.attributes.value,
      }));

      setMans(dataReceived);
    }
  }, [mansQuery?.data, mansQuery.error]);

  /* Startup states */
  const [name, setName] = useState("");
  const [website, setWebsite] = useState("");
  const [websiteError, setFoundingWebsiteError] = useState("");
  function isUrlValid(userInput) {
    var res = userInput.match(
      /^((www|WWW)\.){1}?([a-zA-Z0-9]+([-_.]{1}[a-zA-Z0-9]+)+(\.[a-zA-Z0-9]+)*)/g
    );
    if (res == null) return false;
    else return true;
  }
  const [headquarters, setHeadquarters] = useState("");

  const [personalMail, setPersonalMail] = useState("");
  const [personalMailError, setPersonalMailError] = useState("");

  const [companyMail, setCompanyMail] = useState("");
  const [companyMailError, setCompanyMailError] = useState("");

  const [foundingYear, setFoundingYear] = useState("");
  const [foundingYearError, setFoundingYearError] = useState("");

  const [emp, setEmp] = useState("");
  const [empError, setEmpError] = useState("");

  /* Startup Selects */
  const [ecosystem, setEcosystem] = useState("");
  const [ecosystemError, setEcosystemError] = useState("");
  function handleChangeEcosystem(selectedOption) {
    setEcosystem(selectedOption.value);
    setEcosystemError("");
  }

  const [legalForm, setLegalForm] = useState("");
  const [legalFormError, setLegalFormError] = useState("");
  function handleChangeLegalForm(selectedOption) {
    setLegalForm(selectedOption.value);
    setLegalFormError("");
  }

  const [businessModel, setBusinessModel] = useState("");
  const [businessModelError, setBusinessModelError] = useState("");
  function handleChangeBusinessModel(selectedOption) {
    setBusinessModel(selectedOption.value);
    setBusinessModelError("");
  }

  const [industry, setIndustry] = useState("");
  const [industryError, setIndustryError] = useState("");
  function handleChangeIndustry(selectedOption) {
    setIndustry(selectedOption.value);
    setIndustryError("");
  }

  /* intrange */
  const [intrange, setIntrange] = useState("");
  const [intrangeError, setIntrangeError] = useState("");
  function handleChangeintrange(selectedOption) {
    setIntrange(selectedOption.value);
    setIntrangeError("");
  }

  // WDW state
  const [wdw, setWdw] = useState("");
  const [wdwError, setWdwError] = useState("");
  const handleWdwChange = (selectedOption) => {
    setWdw(selectedOption.value);
    setWdwError("");
  };

  // MCN state
  const [mcn, setMcn] = useState("");
  const [mcnError, setMcnError] = useState("");
  const handleMcnChange = (selectedOption) => {
    setMcn(selectedOption.value);
    setMcnError("");
  };

  // MAN state
  const [man, setMan] = useState("");
  const [manError, setManError] = useState("");
  const handleManChange = (selectedOption) => {
    setMan(selectedOption.value);
    setManError("");
  };

  // FDN state
  const [fdn, setFdn] = useState("");
  const [fdnError, setFdnError] = useState("");
  const handleFdnChange = (selectedOption) => {
    setFdn(selectedOption.value);
    setFdnError("");
  };

  const [success, setSuccess] = useState();

  const [createStartup, { loadingStartup }] = useMutation(CREATE_STARTUP, {
    onCompleted: (_providerData) => {
      setFoundingWebsiteError("");
      setPersonalMailError("");
      setCompanyMailError("");
      setFoundingYearError("");
      setEmpError("");
      setFdnError("");
      setWdwError("");
      setManError("");
      setSuccess(true);
    },
    onError: (error) => {
      if (error.message === "This attribute must be unique") {
        setPersonalMailError("An account with this email already exists.");
      }
      if (
        [
          "FOU must be greater than or equal to 1990",
          "FOU must be less than or equal to 2030",
        ].includes(error.message)
      ) {
        setFoundingYearError("Please enter a number between 1990 and 2030.");
      }
    },
  });

  const handleSubmit = (e) => {
    setLegalFormError("");
    setFoundingWebsiteError("");
    setCompanyMailError("");
    setFoundingYearError("");
    setEmpError("");

    e.preventDefault();
    if (legalForm === "") {
      setLegalFormError("Please select a legal form from the list.");
      document.getElementById("select-legalForm").scrollIntoView();
    } else if (industry === "") {
      setIndustryError("Please select an industry from the list.");
      document.getElementById("select-industry").scrollIntoView();
    } else if (ecosystem === "") {
      setEcosystemError("Please select a startup ecosystem from the list.");
      document.getElementById("select-ecosystem").scrollIntoView();
    } else if (!isUrlValid(website)) {
      setFoundingWebsiteError("Enter a valid website address");
      document.getElementById("input-url").scrollIntoView();
    } else if (!parseInt(foundingYear)) {
      setFoundingYearError("Please enter a number between 1990 and 2030.");
      document.getElementById("input-foundingYear").scrollIntoView();
    } else if (intrange === "") {
      setIntrangeError("Please select a valid entry.");
      document.getElementById("select-Int").scrollIntoView();
    } else if (fdn === "") {
      setFdnError("Please select a valid entry.");
      document.getElementById("select-fdn").scrollIntoView();
    } else if (wdw === "") {
      setWdwError("Please select a valid entry.");
      document.getElementById("select-wdw").scrollIntoView();
    } else if (mcn === "") {
      setMcnError("Please select a valid entry.");
      document.getElementById("select-mcn").scrollIntoView();
    } else if (man === "") {
      setManError("Please select a valid entry.");
      document.getElementById("select-man").scrollIntoView();
    } else if (!parseInt(emp)) {
      setEmpError("Please enter a number between 1990 and 2030.");
      document.getElementById("input-foundingYear").scrollIntoView();
    } else if (personalMail === companyMail) {
      setCompanyMailError("Please do not use the same email address.");
      document.getElementById("input-foundingCompanyMail").scrollIntoView();
    } else {
      createStartup({
        variables: {
          NAM: name,
          website: website,
          HDQ: headquarters,
          ECO: ecosystem,
          IND: industry,
          INT: intrange,
          LEG: legalForm,
          MOD: businessModel,
          EMP: parseInt(emp),
          FDN: fdn,
          WDW: wdw,
          MCN: mcn,
          MAN: man,
          FOU: parseInt(foundingYear),
          MAIL_PERSONAL: personalMail,
          MAIL_COMPANY: companyMail,
        },
      });
    }
  };

  return (
    <div className="absolute left-0 right-0 flex flex-col items-center overflow-y-auto bottom-14 top-20">
      {!success && (
        <>
          <h1 className="m-2 mt-10">Register your Startup</h1>
          <form onSubmit={handleSubmit} className="w-full max-w-xl p-4 m-auto">
            <div className="flex-col w-full center">
              <label className="ml-2 align-middle inline-block">
                What is the name of your startup?
                <span className="required">*</span>
              </label>
              <input
                required
                className="w-full"
                type="text"
                placeholder="Name of your startup"
                value={name}
                onChange={(e) => setName(e.target.value)}
              ></input>
              <label className="ml-2 align-middle inline-block">
                URL of the website<span className="required">*</span>
              </label>
              <input
                required
                id="input-url"
                className="w-full"
                type="text"
                placeholder="URL of the website"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
              ></input>
              {websiteError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{websiteError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                Where is your startup headquarter located?
                <span className="required">*</span>
              </label>
              <input
                required
                className="w-full"
                type="text"
                placeholder="City"
                value={headquarters}
                onChange={(e) => setHeadquarters(e.target.value)}
              ></input>
              <label className="ml-2 align-middle inline-block">
                Which startup ecosystem would you count yourself in?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-ecosystem"
                onChange={handleChangeEcosystem}
                options={ecosystems}
                placeholder="Startup ecosystem"
              />
              {ecosystemError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{ecosystemError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                What legal form does your startup currently have?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-legalForm"
                onChange={handleChangeLegalForm}
                options={legalForms}
                placeholder="Legal form"
              />
              {legalFormError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{legalFormError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                Whats your Business Model?<span className="required">*</span>
              </label>
              <CustomSelect
                id="select-business-model"
                onChange={handleChangeBusinessModel}
                options={businessModels}
                placeholder="Business model"
              />
              {businessModelError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{businessModelError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                What industry do you operate in?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-industry"
                onChange={handleChangeIndustry}
                options={industries}
                placeholder="Industry"
              />
              {industryError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{industryError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                When was your startup founded?
                <span className="required">*</span>
              </label>
              <input
                required
                className="w-full"
                type="number"
                id="input-foundingYear"
                placeholder="Founding year"
                value={foundingYear}
                onChange={(e) => setFoundingYear(e.target.value)}
              />
              {foundingYearError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{foundingYearError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                How many employees does your startup currently have?
                <span className="required">*</span>
              </label>
              <input
                required
                className="w-full"
                type="number"
                id="input-emp"
                placeholder="year"
                value={emp}
                onChange={(e) => setEmp(e.target.value)}
              />
              {empError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{empError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                Are you hiring or offering internships?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-int"
                onChange={handleChangeintrange}
                options={intranges}
                placeholder="yes or no"
              />
              {intrangeError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{intrangeError}</p>
              )}

              <label className="ml-2 align-middle inline-block">
                Is your next fundraising round planed for the upcoming 12
                months?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-fdn"
                onChange={handleFdnChange}
                options={fdns}
                placeholder="yes or no"
              />
              {fdnError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{fdnError}</p>
              )}

              <label className="ml-2 align-middle inline-block">
                Where do you work?<span className="required">*</span>
              </label>
              <CustomSelect
                id="select-wdw"
                onChange={handleWdwChange}
                options={wdws}
                placeholder="Please select"
              />
              {wdwError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{wdwError}</p>
              )}

              <label className="ml-2 align-middle inline-block">
                Are you a member in a co-working network?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-mcn"
                onChange={handleMcnChange}
                options={mcns}
                placeholder="Please select"
              />
              {mcnError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{mcnError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                Are you a member in another network?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-man"
                onChange={handleManChange}
                options={mans}
                placeholder="Please select"
              />
              {manError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{manError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                Your email<span className="required">*</span>
              </label>
              <input
                required
                className="w-full"
                type="email"
                placeholder="Your email"
                value={personalMail}
                onChange={(e) => setPersonalMail(e.target.value)}
              />
              {personalMailError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{personalMailError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                Public company email<span className="required">*</span>
              </label>
              <input
                required
                id="input-foundingCompanyMail"
                className="w-full"
                type="email"
                placeholder="Public company email"
                value={companyMail}
                onChange={(e) => setCompanyMail(e.target.value)}
              />
              {companyMailError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{companyMailError}</p>
              )}

              <div className="flex mt-4 mb-6 ml-2 text-left items-left">
                <input required id="privacy" type="checkbox"></input>
                <label htmlFor="privacy" className="ml-2 align-middle">
                  I agree to the{" "}
                  <a href="https://station-frankfurt.de/datenschutzerklaerung/">
                    privacy policy.
                  </a>
                </label>
                <span className="required">*</span>
              </div>
              <button
                id="submit"
                type="submit"
                className="w-full mb-4 tertiary link-bold"
                disabled={loadingStartup}
              >
                Register startup
              </button>
            </div>
          </form>
        </>
      )}
      {success && (
        <div className="items-center mx-auto mt-8 text-center">
          <h2>We received the registration of your startup.</h2>
          <p className="mt-4 text-copy-main-regular">
            Your registration will now be verified. This can take a couple of
            days. <br />
            You will be informed of the outcome by e-mail.
          </p>
          <Link to="/" className="items-center w-full">
            <li className="float-none w-56 mx-auto mt-8 list-none topbar-link-primary">
              Display Startup Map
            </li>
          </Link>
        </div>
      )}
    </div>
  );
}

export default CreateStartup;
